<wms-dialog id="pushToExternalVCSModal" customClasses="small vcs-add-dialog">
    <wms-dialog-header (onClose)="vcsService.closeDialogWithId('pushToExternalVCSModal')"
        title="{{locale['LABEL_VCS_MENU_ADD_EXTERNAL_PROJECT']}}"
        helpTitle="{{locale['LABEL_VCS_MENU_ADD_EXTERNAL_PROJECT']}}"
        helpLink="https://docs.wavemaker.com/learn/app-development/dev-integration/developer-collaboration/#push-to-external-repo"
        customClass="pullChanges-header"></wms-dialog-header>
    <wms-dialog-body>
        <form enctype="multipart/form-data" class="wm-form" (keydown.enter)="addToExternalVCS()">
            <wms-message *ngIf="vcsService.msgData.show" hideclose="true"
                [scopeDataset]="vcsService.msgData"></wms-message>
            <div class="form-group app-composite-widget clearfix">
                <ul class="vcs-provider-list col-xs-12 form-group ">
                    <li class="vcs-provider col-xs-3" *ngFor="let provider of vcsService.vcsProviders; let i = index"
                        (click)="vcsService.selectVCSProvider(provider, true)">
                        <div class="vcs-provider-details" [ngClass]="{'active': provider.active}">
                            <img [src]="provider.icon" [alt]="provider.text">
                        </div>
                    </li>
                </ul>
            </div>
            <div class="vcs-form">
                <label class="control-label app-label">{{vcsService.selectedProvider.provider_hint}}</label>
                <div class="form-group app-composite-widget clearfix">
                    <label class="control-label app-label col-xs-3 required">{{locale['LABEL_USERNAME']}}:</label>
                    <div class="col-xs-9">
                        <input type="text" class="form-control app-textbox"
                            (change)="vcsService.validateVCSConfigAndGetVCSBranches()" name="vcsUsername"
                            [(ngModel)]="vcsService.vcsConfig.username">
                    </div>
                </div>
                <div class="form-group app-composite-widget clearfix" *ngIf="vcsService.vcsConfig.type === 'GIT_HUB'">
                    <label
                        class="control-label app-label col-xs-3 required">{{locale['LABEL_GIT_ACCESS_TOKEN']}}:</label>
                    <div class="col-xs-9">
                        <input type="password" class="form-control app-textbox"
                            (change)="vcsService.validateVCSConfigAndGetVCSBranches()" name="vcsAccessToken"
                            [(ngModel)]="vcsService.vcsConfig.password" autocomplete="new-password">
                        <p class="text-muted">{{locale['MESSAGE_REPO_CREDENTIALS_NOTE']}}</p>
                        <div>
                            <p><a href="{{locale['GIT_TOKEN_DOC_LINK']}}"
                                    target="_blank">{{locale['MESSAGE_GIT_TOKEN_NOTE']}}</a></p>
                        </div>
                    </div>
                </div>
                <div class="form-group app-composite-widget clearfix" *ngIf="vcsService.vcsConfig.type !== 'GIT_HUB'">
                    <label class="control-label app-label col-xs-3 required">{{locale['LABEL_PASSWORD']}}:</label>
                    <div class="col-xs-9">
                        <input type="password" class="form-control app-textbox" name="vcsPassword"
                            (change)="vcsService.validateVCSConfigAndGetVCSBranches()"
                            [(ngModel)]="vcsService.vcsConfig.password" autocomplete="new-password">
                        <p class="text-muted">{{locale['MESSAGE_REPO_CREDENTIALS_NOTE']}}</p>
                    </div>
                </div>
                <div class="form-group app-composite-widget clearfix">
                    <label class="control-label app-label col-xs-3 required">{{locale['LABEL_REPO_URL']}}:</label>
                    <div class="col-xs-9">
                        <input type="text" class="form-control app-textbox" name="vcsUrl"
                            (change)="vcsService.checkIsPublicRepo();vcsService.validateVCSConfigAndGetVCSBranches()"
                            [title]="vcsService.vcsConfig.url" [(ngModel)]="vcsService.vcsConfig.url"
                            [placeholder]="vcsService.selectedProvider.placeholder">
                        <p class="text-muted">{{locale['MESSAGE_REPO_URL_NOTE']}}</p>
                    </div>
                </div>
                <div class="form-group app-composite-widget clearfix">
                    <label class="control-label app-label col-xs-3 required">{{locale['LABEL_REPO_BRANCH']}}:</label>
                    <div class="col-xs-9">
                        <wms-typeahead name="vcsBranch" class="branches-list typeahead" [editable]="true"
                            (onSelect)="vcsService.onBranchSelect($event)" (onClear)="vcsService.onBranchUnSelect()"
                            [model]="vcsService.vcsBranchName" [options]="vcsService.vcsBranchesList"
                            [modelType]="'string'"></wms-typeahead>
                    </div>
                </div>
                <button hidden></button>
            </div>

        </form>
    </wms-dialog-body>
    <wms-dialog-footer>
        <button class="btn button-secondary app-button"
            (click)="vcsService.closeDialogWithId('pushToExternalVCSModal')">{{locale['LABEL_CANCEL']}}</button>
        <button class="btn btn-primary" (click)="addToExternalVCS()"
            [disabled]="vcsService.isExportDisabled">{{locale['LABEL_EXPORT']}}</button>
    </wms-dialog-footer>
</wms-dialog>

<wms-vcs-pull-dialog [vcsAction]="'pushExternal'" id="pushExternalRepoChangesModal"></wms-vcs-pull-dialog>
